import Plausible from 'plausible-tracker'

export const {trackPageview, trackEvent} = Plausible({
    domain: (site_objects.environment === 'development') ? 'mindhelpergstg.wpengine.com' : location.hostname,
    trackLocalhost: true
});